import { Route } from '@angular/router';
import { HomeComponent } from './feature/home/home.component';
import { TermAndConditionComponent } from './feature/term-and-condition/term-and-condition.component';
import { PrivacyPolicyComponent } from './feature/privacy-policy/privacy-policy.component';
import { CookiesPolicyComponent } from './feature/cookies-policy/cookies-policy.component';
import { Lib404PageNotFoundComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';
import { TirewarrantyPolicy180DayComponent } from './feature/tirewarranty-policy-180-day/tirewarranty-policy-180-day.component';
import { FiveYearWarrantyPolicyComponent } from './feature/five-year-warranty-policy/five-year-warranty-policy.component';

export enum ROUTER_TOKENS {
  SAMSON = 'SAMSON',
  // HOME = 'home',
  PRODUCTS = 'products',
  PROMOTIONS = 'promotions',
  VIDEOS = 'videos',
  NEWS = 'news',
  ARTICLE = 'article',
  BRANCHES = 'branches',
  ABOUT_US = 'about-us',
  FRANCHISE = 'franchise',
  AFTER_SALE_SERVICE = 'after-sale-service',
  WARRANTY_POLICY = 'warrantyPolicy',
  CONTACT_US = 'contact-us',
  TERM_AND_CONDITION = 'term-and-condition',
  PRIVACY_POLICY = 'privacy-policy',
  COOKIES_POLICY = 'cookies-policy',
  TIRE = 'tire',
  LUBRICANT = 'lubricant',
  BREAK = 'brake',
  GALLERY = 'gallery',
  TIREWARRANTY_POLICY_60_DAY = 'tirewarranty-policy-60-day',
  TIREWARRANTY_POLICY_180_DAY = 'tirewarranty-policy-180-day',
  FIVE_YEAR_WARRANTY_POLICY = '5-year-warranty-policy',
}

export const appRoutes: Route[] = [
  // {
  //   path: '',
  //   redirectTo: ROUTER_TOKENS.HOME,
  //   pathMatch: 'full',
  // },
  {
    path: '',
    component: HomeComponent,
    data: {
      name: ROUTER_TOKENS.SAMSON,
      title: 'SAMSON TYRE Thailand | Samson Tyre ยางรถเก๋ง กระบะ และ SUV | Power Within',
      description:
        'ยางแซมซั่น Samson Tyre ครบ 7 รุ่น 62 ขนาด เลือกให้เหมาะกับรถและการขับขี่ของคุณ พร้อมประกันอุบัติเหตุ 180 วัน และประกันคุณภาพ 5 ปี ตามเงื่อนไขบริษัทฯ | SAMSON TYRE Thailand',
      keywords:
        'ยาง advance, ยาง advance ราคา, ADVANCE TYRE Thailand, ยางคุ้มค่าทุกเส้นทาง advance, เปลี่ยนยางรถยนต์ advance, ราคายางรถยนต์ advance',
      robots: 'index, follow',
      canonical: 'https://advancetyre.in.th',
      publisher: 'SAMSON',
    },
  },
  {
    path: ROUTER_TOKENS.TERM_AND_CONDITION,
    component: TermAndConditionComponent,
    data: {
      name: ROUTER_TOKENS.SAMSON,
      title: 'ข้อกำหนดและเงื่อนไขการใช้บริการ | SAMSON TYRE Thailand',
      description:
        'เอกสารข้อกำหนดและเงื่อนไขการใช้เว็บไซต์/บริการของ SAMSON TYRE ครอบคลุมขอบเขตการใช้งาน สิทธิและหน้าที่ของผู้ใช้ หลักเกณฑ์ทางกฎหมาย ข้อจำกัดความรับผิด และแนวทางการติดต่อ สร้างความโปร่งใสและความมั่นใจในการใช้งานทุกส่วนของเว็บไซต์ | SAMSON TYRE Thailand',
      // keywords: '',
      // robots: 'index, follow',
      // canonical: 'https://advancetyre.in.th/term-and-condition',
      // publisher: 'ADVANCE',
    },
  },
  {
    path: ROUTER_TOKENS.PRIVACY_POLICY,
    component: PrivacyPolicyComponent,
    data: {
      name: ROUTER_TOKENS.SAMSON,
      title: 'นโยบายความเป็นส่วนตัว | SAMSON TYRE Thailand',
      description:
        'อธิบายการเก็บ ใช้ เปิดเผย และคุ้มครองข้อมูลส่วนบุคคลตามกฎหมายที่เกี่ยวข้อง ระบุสิทธิของเจ้าของข้อมูล ช่องทางติดต่อ และมาตรการรักษาความปลอดภัย เพื่อให้คุณใช้งานเว็บไซต์และบริการของ ADVANCE TYRE ได้อย่างมั่นใจ โปร่งใส และสอดคล้องข้อกำหนดเสมอ | SAMSON TYRE Thailand',
      // keywords: '',
      // robots: 'index, follow',
      // canonical: 'https://advancetyre.in.th/privacy-policy',
      // publisher: 'ADVANCE',
    },
  },
  {
    path: ROUTER_TOKENS.COOKIES_POLICY,
    component: CookiesPolicyComponent,
    data: {
      name: ROUTER_TOKENS.SAMSON,
      title: 'นโยบายคุกกี้ | SAMSON TYRE Thailand',
      description:
        'ชี้แจงประเภทคุกกี้ วัตถุประสงค์ด้านฟังก์ชัน การวิเคราะห์ และการโฆษณา อธิบายผลต่อประสบการณ์ผู้ใช้ พร้อมวิธีตั้งค่า/จัดการความยินยอมในเบราว์เซอร์ คุณสามารถปรับเปลี่ยนการยินยอมได้ทุกเมื่อ เพื่อให้การใช้งานเว็บไซต์เหมาะกับความต้องการมากที่สุด | SAMSON TYRE Thailand',
      // keywords: '',
      // robots: 'index, follow',
      // canonical: 'https://advancetyre.in.th/cookies-policy',
      // publisher: 'ADVANCE',
    },
  },
  {
    path: ROUTER_TOKENS.PRODUCTS,
    loadChildren: () => import('./feature/products/products.routes').then((m) => m.productRoutes),
  },
  {
    path: ROUTER_TOKENS.PROMOTIONS,
    loadChildren: () => import('./feature/promotions/promotions.routes').then((m) => m.promotionsRoutes),
  },
  {
    path: ROUTER_TOKENS.VIDEOS,
    loadChildren: () => import('./feature/videos/videos.routes').then((m) => m.videosRoutes),
  },
  {
    path: ROUTER_TOKENS.NEWS,
    loadChildren: () => import('./feature/news/news.routes').then((m) => m.newsRoutes),
  },
  {
    path: ROUTER_TOKENS.ARTICLE,
    loadChildren: () => import('./feature/article/article.routes').then((m) => m.articleRoutes),
  },
  {
    path: ROUTER_TOKENS.BRANCHES,
    loadChildren: () => import('./feature/branches/branches.routes').then((m) => m.branchesRoutes),
  },
  {
    path: ROUTER_TOKENS.ABOUT_US,
    loadChildren: () => import('./feature/about-us/about-us.routes').then((m) => m.aboutUsRoutes),
  },
  {
    path: ROUTER_TOKENS.GALLERY,
    loadChildren: () => import('./feature/gallery/gallery.routes').then((m) => m.galleryRoutes),
  },
  {
    path: ROUTER_TOKENS.FIVE_YEAR_WARRANTY_POLICY,
    component: FiveYearWarrantyPolicyComponent,
  },
  {
    path: ROUTER_TOKENS.TIREWARRANTY_POLICY_180_DAY,
    component: TirewarrantyPolicy180DayComponent,
    data: {
      name: ROUTER_TOKENS.SAMSON,
      title: 'นโยบายการรับประกัน 180 วัน | SAMSON TYRE Thailand',
      description:
        'อธิบายการเก็บ ใช้ เปิดเผย และคุ้มครองข้อมูลส่วนบุคคลตามกฎหมายที่เกี่ยวข้อง ระบุสิทธิของเจ้าของข้อมูล ช่องทางติดต่อ และมาตรการรักษาความปลอดภัย เพื่อให้คุณใช้งานเว็บไซต์และบริการของ ADVANCE TYRE ได้อย่างมั่นใจ โปร่งใส และสอดคล้องข้อกำหนดเสมอ | SAMSON TYRE Thailand',
      // keywords: '',
      // robots: 'index, follow',
      // canonical: 'https://advancetyre.in.th/tirewarranty-policy-180-day',
      // publisher: 'ADVANCE',
    },
  },
  {
    path: '**',
    component: Lib404PageNotFoundComponent,
  },
];
